import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLanguage } from '../contexts/LanguageContext';
import { Home, Search, ArrowRight, Brain, Heart, Wind } from 'lucide-react';
import { Button } from '../components/ui/button';

const NotFound = () => {
  const navigate = useNavigate();
  const { t } = useLanguage();
  const [float, setFloat] = useState(false);

  useEffect(() => {
    setFloat(true);
  }, []);

  return (
    <div className="min-h-screen bg-[#0B1220] pt-32 pb-24 relative overflow-hidden">
      {/* Animated Background Elements */}
      <div className="absolute inset-0 opacity-10">
        <div className={`absolute top-20 left-10 transition-all duration-[3000ms] ${float ? 'translate-y-0' : 'translate-y-10'}`}>
          <Brain className="w-20 h-20 text-yamai-purple-400" />
        </div>
        <div className={`absolute bottom-32 right-20 transition-all duration-[3500ms] ${float ? 'translate-y-0' : '-translate-y-10'}`}>
          <Heart className="w-24 h-24 text-yamai-cyan-400" />
        </div>
        <div className={`absolute top-1/2 right-10 transition-all duration-[4000ms] ${float ? 'translate-x-0' : 'translate-x-10'}`}>
          <Wind className="w-16 h-16 text-yamai-purple-300" />
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        {/* 404 Number */}
        <div className="text-center mb-8">
          <h1 className="text-[150px] md:text-[200px] font-bold leading-none">
            <span className="bg-gradient-to-r from-yamai-cyan-400 via-yamai-purple-500 to-yamai-cyan-400 bg-clip-text text-transparent">
              404
            </span>
          </h1>
        </div>

        {/* Content */}
        <div className="text-center mb-12">
          <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
            {t('notFound.title')}
          </h2>
          <p className="text-lg text-gray-400 max-w-2xl mx-auto">
            {t('notFound.subtitle')}
          </p>
        </div>

        {/* Action Buttons */}
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center mb-16">
          <Button
            onClick={() => navigate('/')}
            className="group px-8 py-6 rounded-xl bg-gradient-to-r from-yamai-cyan-500 to-yamai-purple-600 hover:shadow-lg hover:shadow-yamai-cyan-500/50 transition-all duration-300 text-white font-semibold text-lg"
          >
            <Home className="w-5 h-5 mr-2" />
            {t('notFound.backHome')}
            <ArrowRight className="w-5 h-5 ml-2 group-hover:translate-x-1 transition-transform" />
          </Button>

          <Button
            onClick={() => navigate('/projects')}
            variant="outline"
            className="px-8 py-6 rounded-xl border-2 border-yamai-cyan-400/50 hover:border-yamai-cyan-400 hover:bg-yamai-cyan-400/10 transition-all duration-300 text-white font-semibold text-lg"
          >
            <Search className="w-5 h-5 mr-2" />
            {t('notFound.exploreProjects')}
          </Button>
        </div>

        {/* Quick Links */}
        <div className="bg-[#1F2A3A]/50 backdrop-blur-md rounded-2xl border border-white/10 p-8">
          <h3 className="text-xl font-bold text-white mb-6 text-center">
            Quick Links
          </h3>
          <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
            {[
              { label: t('nav.home'), path: '/' },
              { label: t('nav.projects'), path: '/projects' },
              { label: t('nav.about'), path: '/about' },
              { label: t('nav.contact'), path: '/contact' },
            ].map((link, index) => (
              <button
                key={index}
                onClick={() => navigate(link.path)}
                className="px-4 py-3 rounded-xl bg-white/5 hover:bg-white/10 border border-white/10 hover:border-yamai-cyan-400/50 transition-all duration-300 text-white font-medium text-center"
              >
                {link.label}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default NotFound;
